import { render, staticRenderFns } from "./EditarQuestionario.vue?vue&type=template&id=0241cebf&scoped=true"
import script from "./EditarQuestionario.vue?vue&type=script&lang=js"
export * from "./EditarQuestionario.vue?vue&type=script&lang=js"
import style0 from "./EditarQuestionario.vue?vue&type=style&index=0&id=0241cebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241cebf",
  null
  
)

export default component.exports